var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "g-recaptcha",
    attrs: {
      "data-size": "invisible",
      "data-callback": "recaptchaCallback",
      "data-recaptcha-id": _vm.grecaptchaId,
      "data-sitekey": _vm.sitekey,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }